module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Gym_D4_cam4.dffe35d2.jpg";